/* eslint-disable no-undef, no-unused-vars, class-methods-use-this */
import '../../scss/base.scss';
import '../../scss/components/uppy.scss';
import '@fancyapps/fancybox/dist/jquery.fancybox.css';
import '../../scss/select2-bootstrap.scss';

import Swal from 'sweetalert2';
import * as Bootstrap from 'bootstrap';

import htmx from 'htmx.org';

import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import '@popperjs/core/dist/umd/popper.min.js';

import {humanDate, humanDateShort} from '@canopyllc/roots/utils/dates.js';
import {escapeHtml} from '@canopyllc/roots/utils/stringUtil.js';
import {generateQRCode} from '@/js/utils/urls';
import API from '../utils/api.js';
import {snackbar} from '../utils/sweetAlert2.js';
import {initCopyButtons} from '@canopyllc/roots/utils/clipboard.js';
import Themes from './themes.js';
import {
  BaseAPI, BaseFilters, BaseUtils, BootstrapDependencies, Nav,
} from './utils.js';
import './icons.js';

window.generateQRCode = generateQRCode;
window.htmx = htmx;
window.bootstrap = Bootstrap;

class BaseJS {
  constructor() {
    // es6 exports
    this.swal = Swal;
    this.bootstrap = Bootstrap;

    this.snackbar = snackbar;
    this.humanDate = humanDate;
    this.humanDateShort = humanDateShort;
    this.escapeHtml = escapeHtml;

    this.initPrintBtn();
    this.initBackButton();
    this.initAvatarFallback();
    this.initTabDeepLink();
    initCopyButtons();
  }

  initPrintBtn() {
    Array.from(document.querySelectorAll('[data-js="print-btn-onclick"]')).forEach(
      (element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault();
          window.print();
        });
      },
    );
  }

  initBackButton() {
    Array.from(document.querySelectorAll('[data-js="history-back-btn-onclick"]')).forEach(
      (element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault();
          window.history.go(-1);
        });
      },
    );
  }

  // Avatars (`c-user-avatar`) render colored initials with the profile photo
  // overlaid as an <img>. When the photo 404s we drop the <img> so the initials
  // show through. CSP (`strict-dynamic`, no `unsafe-inline`) blocks an inline
  // `onerror`, so the fallback lives here. `error` events don't bubble, hence the
  // capture-phase listener — it also covers avatars injected after load (e.g. the
  // directory's AJAX rows).
  initAvatarFallback() {
    document.addEventListener('error', (event) => {
      const el = event.target;
      if (el.tagName === 'IMG' && el.classList.contains('c-user-avatar__img')) {
        el.remove();
      }
    }, true);

    // Images that failed before this script ran won't fire a fresh error event —
    // sweep the initial render for already-broken ones.
    document.querySelectorAll('img.c-user-avatar__img').forEach((img) => {
      if (img.complete && img.naturalWidth === 0) {
        img.remove();
      }
    });
  }

  // Bootstrap hides every inactive `.tab-pane`, so a `#anchor` pointing inside one lands on
  // the default tab with the target invisible. Show the tab that owns the anchor instead, so
  // pages can be deep linked to a specific tab (e.g. a child registration linking to the
  // group admin's Payment Information).
  initTabDeepLink() {
    const target = document.getElementById(window.location.hash.slice(1));
    if (!target) return;

    const pane = target.closest('.tab-pane');
    if (!pane) return;

    const trigger = document.querySelector(`[data-bs-toggle="tab"][data-bs-target="#${CSS.escape(pane.id)}"]`);
    if (!trigger) return;

    Bootstrap.Tab.getOrCreateInstance(trigger).show();
    target.scrollIntoView();
  }

  /**
   * Initializes download links with API functionality
   * @param {string} csrfToken - The CSRF token to use for API requests
   */
  initializeDownloadLinks(csrfToken) {
    const api = new API(csrfToken),
          downloadLinks = document.querySelectorAll('.download-link');

    downloadLinks.forEach((link) => {
      link.addEventListener('click', async function(event) {
        event.preventDefault();
        const downloadUrl = this.getAttribute('data-download-url');
        try {
          const response = await api.get(downloadUrl),
                {data} = response;
          if (data.url) {
            window.open(data.url, '_blank');
          } else {
            throw new Error('Download URL not found in response');
          }
        } catch (err) {
          snackbar({
            text: err.response.data.error || 'An unexpected error occurred.',
            type: 'error',
          });
        }
      });
    });
  }
}
window.base_js = new BaseJS();

new Nav();

window.themes = Themes;

window.baseFilters = new BaseFilters();

window.bootstrapDependencies = new BootstrapDependencies();

window.baseAPI = new BaseAPI();

window.baseUtils = new BaseUtils();

/**
 * Set module options
 * Leaving this here for now because I don't want to refactor all the usages. It should probably be re-thought anyway.
 *
 * @param {object} base_obj Is the base object that all options will be merged into.
 * @param {object} defaultOptions The default options used in the module.
 * @param {object} options The options passed to the module when initialized.
 * @param {array} required_options An array of options that are required for the module to work.
 */
window.SetModuleOptions = function(base_obj, defaultOptions, options, required_options = []) {
  this.defaultOptions = defaultOptions;
  this.options = options;
  this.required_options = required_options;
  this.check_required_options();
  this.remove_undefined_options();
  $.extend(base_obj, this.defaultOptions, this.options);
};
window.SetModuleOptions.prototype = {
  check_required_options() {
    let self = this;

    $.each(this.required_options, (i, k) => {
      if (self.options[k] === undefined) {
        console.error(`The ${k} option is required`);  
      }
    });
  },
  remove_undefined_options() {
    let self = this;

    $.each(self.options, (k, v) => {
      if (self.defaultOptions[k] === undefined) {
        delete self.options[k];
      }
    });
  },
};

// @todo - replace this with exports from utils/sweetAlert2.js
window.swal2_wrapper = function(...argList) {
  let options = argList[0];
  if (typeof options === 'string') {
    options = {
      title: argList[0],
      text: argList[1],
      icon: argList[2],
    };
  }

  let type = options.type || options.icon,
      confirmButton = 'btn btn-danger';

  if (type === 'success') confirmButton = 'btn btn-primary';
  if (type === 'warning') confirmButton = 'btn btn-warning';

  let defaultOptions = {
    buttonsStyling: false,
    customClass: {
      container: `c-swal c-swal--${type}`,
      confirmButton,
      cancelButton: 'btn btn-naked',
    },
    focusConfirm: false,
  },
      notifications = null;

  if (options.notifications) {
    notifications = options.notifications;
    delete options.notifications;
  }

  if (options.type) {
    defaultOptions.icon = options.type; // v9 renames type to icon
    delete options.type;
  }
  options = $.extend(defaultOptions, options);

  if (options.toast === true) {
    delete options.focusConfirm;
  }

  if (notifications) {
    let notificationAlert = Swal.mixin(options);
    return notificationAlert.queue(notifications);
  }
  return base_js.swal.fire(options);
  // return Swal.fire(options);
};
